import React from 'react';

import { Box, Typography } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Element } from 'react-scroll';

import TestIcon from '../../../../assets/icons/TestIcon';
import { colorsPalette } from '../../../../theme';
import useStyles from '../PathwayTestBlock/styles';

interface PathwayTestBlockProps {
  id?: string;
  wrapperClass?: string;
}

const PathwayTestBlock: React.FC<PathwayTestBlockProps> = ({ id, wrapperClass }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <Element id={`test-${id}`} className={cx(classes.wrapper, wrapperClass)}>
      <Box className={classes.leftPanel} data-testid="testComingSoonBlock">
        <TestIcon className={classes.testIcon} color={colorsPalette.blue} />
        <Box>
          <Typography className={classes.title}>{t('page.pathway.testComingSoon')}</Typography>
          <Typography className={classes.description}>
            {t('page.pathway.testComingSoonDesc')}
          </Typography>
        </Box>
      </Box>
    </Element>
  );
};

export default PathwayTestBlock;
